import { render, staticRenderFns } from "./ProductData.vue?vue&type=template&id=21a50133&scoped=true"
import script from "./ProductData.vue?vue&type=script&lang=js"
export * from "./ProductData.vue?vue&type=script&lang=js"
import style0 from "./ProductData.vue?vue&type=style&index=0&id=21a50133&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a50133",
  null
  
)

export default component.exports